import React from 'react'
import './index.scss'

interface IProps {
    showHfa?: boolean
}

const PublisherContactCondensed = (props: IProps) => (
    <div className="contact-details-expanded">
        {props.showHfa && (
            <div className="details-container">
                <p className="small-2">212-834-0100</p>
                <p className="small-2">licensing@harryfox.com</p>
                <p className="small-2 address">
                    HFA
                    <br />
                    40 Wall Street
                    <br />
                    New York, NY 10005
                </p>
            </div>
        )}
    </div>
)

export default PublisherContactCondensed
